<template>
  <div>
    <main>
      <v-card class="login-form">
        <h4>Forgot Password</h4>
        <v-form @submit.native.prevent="submit()">
          <v-text-field
            label="Email"
            v-model="email"
            required
          ></v-text-field>
          <v-flex class="text-xs-right">
            <v-btn type="submit" dark primary class="margin-off">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-flex>
          <v-alert color="error" class="err" icon="warning" value="true" v-if="err">{{err}}</v-alert>
          <v-alert color="success" class="success" icon="check" value="true" v-if="success">{{success}}</v-alert>
        </v-form>
      </v-card>
    </main>
  </div>
</template>

<script>
  import webHelper from '../helpers/web';

  export default {
    data: () => ({
      email: '',
      err: '',
      success: '',
    }),
    methods: {
      async submit() {
        this.err = '';
        const res = await webHelper.post(this, 'user/forgot', { email: this.email });
        if (res.failed) {
          this.err = 'Failed to make the request.';
          return;
        }
        this.success = 'Password reset email was sent successfully.';
        setTimeout(() => {
          this.success = '';
        }, 3000);
      },
    },
  };
</script>

<style scoped lang="scss">
  main {
    display: flex;
    align-items: center;
    max-width: 500px;
    margin: auto;
    height: 100vh;
  }

  .err {
    margin-bottom: 30px;
  }
  .margin-off {
    margin: 0;
  }
  v-btn {
    position: absolute;
    right: 0;
  }
  .login-form {
    margin: 0 auto;
    width: 100%;
    padding: 50px 40px 20px 40px;
    position: relative;
    a {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue